/*
 * @Author: K
 * @Date: 2022-04-08 16:23:14
 * @LastEditors: owen
 * @LastEditTime: 2022-04-23 00:32:00
 * @FilePath: \app-pcweb\src\store\modules\AuthModule.js
 */
import {
  getLocalStorage,
  getSesStorage,
  getToken,
  setRefreshToken,
  removeLocalStorage,
  removeToken,
  setLocalStorage,
  setToken,
} from "@/lobby_common/utils/auth";
import { ThirdPartySubmissionStorage } from "@/lobby_common/utils/urlInit";
import { eventPost } from "@/lobby_common/utils/eventFunction";
import { adjustTrackEvent } from "@/lobby_common/utils/eventFunction";
import Vue from "vue";
import {
  saveDataToIndexedDB,
  removeDataFromIndexDB,
} from "@/lobby_common/utils/utils";
import { getUserFirstWithdrawHint } from "@/lobby_common/api/payment_gen.js";

// import Store from "@/lobby_common/store/index";
import store from "@/lobby_common/store";
import Bus from "@/lobby_common/utils/bus.js";
import {
  getDeviceInfo,
  getchannel,
  getAdsCode,
  queryToObj,
} from "@/lobby_common/utils/utils.js";
import { repairLoginEvent } from "@/lobby_common/utils/timerFunction.js";
// 红点接口、活动奖励预览
import {
  getRedDot,
  previewActivityReward,
} from "@/lobby_common/api/activity_gen.js";
import { refreshPage, getEnableFeature } from "@/lobby_common/api/basic_gen.js";
import {
  register,
  getUser,
  login,
  loginOut,
  getWallet,
  thirdLogin,
  selectWallet,
} from "@/lobby_common/api/user_gen";
import { setLocale } from "@/lobby_common/locale";
import { getUrlkey, setLangFromUser } from "@/lobby_common/utils/utils.js";
import {
  particleWalletMap,
  disconnectWallet,
} from "@/lobby_common/utils/authLogin.js";
const AuthModule = {
  state: {
    user: {},
    taken: null,
    isLogin: false,
    loginLoading: false,
    ipConfig: null,
    quickLoginInfo: {},
    brandData: {},
    selectCoin: "",
    coinSymbolList: {},
    maintain: null,
    customerService: {},
    firstWithdrawHint: {}, // 首提
    allPoint: [], // 所有需要小红点的菜单
    curPoint: [], // 当前小红点的菜单
    newNotice: false, // 有新通知消息
    unreceivedNoticeObj: false,  // 有未领取邮件
    enableFeature: {
      // 启用的功能，用来判断某活动、任务展不展示
      activityTypes: [],
    },
    downloadRewardClaimStatus: false,
    displayPromoteUrl: "ROW_STATUS_DISABLE", // 公告是否展示邀请 ROW_STATUS_DISABLE ROW_STATUS_ENABLE
  },
  mutations: {
    setDisplayPromoteUrl(state, payload) {
      state.displayPromoteUrl = payload;
      setLocalStorage("displayPromoteUrl", payload);
    },
    setDownloadRewardClaimStatus(state, payload) {
      state.downloadRewardClaimStatus = payload;
      setLocalStorage("downloadRewardClaimStatus", payload);
    },
    setAllPoint(state, payload) {
      state.allPoint = payload;
    },
    setNewNotice(state, payload) {
      state.newNotice = payload;
    },
    setUnreceivedNotice(state, payload) {
      state.unreceivedNoticeObj = payload;
    },
    setCurPoint(state, payload) {
      state.curPoint = payload;
    },
    setAllEnableFeature(state, payload) {
      state.enableFeature = payload;
    },
    setFirstWithdrawHint(state, payload) {
      // 设置首提配置
      const obj = payload || {};
      state.firstWithdrawHint = { ...state.firstWithdrawHint, ...obj };
    },
    wssSetUserInfo(state, payload) {
      const userInfo = state.user || getLocalStorage("USER_DATA");
      state.user = {
        ...userInfo,
        ...payload,
        coinCode: payload.coinCode || userInfo.coinCode,
      };
      setLocalStorage("USER_DATA", state.user);
      if (state.user.coinCode) {
        setLocalStorage("defaultCoinCode", state.user.coinCode);
      } else {
        removeLocalStorage("defaultCoinCode");
      }
      //  处理游戏跳转，
      // console.log("处理游戏跳转，aaaaaaaaaaaaaaaaaaa");
      // if (state.user.in_game_id > 0) {
      //   setLocalStorage("GameboxId", [{ id: state.user.in_game_id > 0 ? state.user.in_game_id : "", brand_id: 0 }]);
      // } else {
      //   setLocalStorage("GameboxId", []);
      // }
    },
    setUser(state, payload) {
      // console.log(state, payload, "state, payloadrtttttttttt");
      console.log("setUser=>>", payload);
      removeLocalStorage("USER_DATA");
      state.user = { ...payload };
      payload &&
        saveDataToIndexedDB("userInfo", {
          ...payload,
        });
      if (payload) {
        setLocalStorage("USER_DATA", payload);
        setLocalStorage("IS_LOGIN", true);
        if (payload.coinCode) {
          setLocalStorage("defaultCoinCode", payload.coinCode);
        } else {
          removeLocalStorage("defaultCoinCode");
        }
        //  处理游戏跳转，
        // console.log("ttttttttttttttt");
        // if (state.user.in_game_id > 0) {
        //   setLocalStorage("GameboxId", [{ id: state.user.in_game_id > 0 ? state.user.in_game_id : "", brand_id: 0 }]);
        // }
      }
    },
    setTaken(state, payload) {
      removeToken();
      if (payload) {
        if (payload.accessToken) {
          state.taken = payload.accessToken;
          setToken(payload.accessToken);
          Bus.$emit("registerWorker");
        }
        if (payload.refreshToken) {
          setRefreshToken(payload.refreshToken);
        }
      } else {
        // 清空
        state.taken = "";
      }
    },
    setIsLogin(state, payload) {
      // 登录状态
      state.isLogin = payload;
      setLocalStorage("IS_LOGIN", payload);
    },
    setLoginLoading(state, payload) {
      // 注册登陆按钮loading
      state.loginLoading = payload;
    },
    setIpConfig(state, payload) {
      state.ipConfig = payload;
      setLocalStorage("IP_CONFIG", payload);
    },
    setQuickLoginInfo(state, payload) {
      state.quickLoginInfo = payload;
    },
    setQuickLoginPassword(state, payload) {
      state.quickLoginInfo.password = payload;
    },
    setQuickLoginAccount(state, payload) {
      state.quickLoginInfo.accountId = payload;
    },
    setBrandData(state, payload) {
      state.brandData = { ...payload };
    },
    setSelectCoin(state, payload) {
      if (state.coinSymbolList[payload]?.symbol) {
        state.user.coin_symbol = state.coinSymbolList[payload].symbol;
      }
      state.selectCoin = payload;
    },
    setCoinSymbolList(state, payload) {
      state.coinSymbolList = payload;
    },
    setMaintain(state, payload) {
      //   console.log(state, payload, "state, payload");
      state.maintain = payload;
    },
    setCustomerService(state, payload) {
      // console.log(payload, "payload============");
      if (!payload.language) return;
      state.customerService = payload.language;
    },
  },
  actions: {
    async getUserFirstWithdrawHintAction({ commit, getters }, payload) {
      if (getters.user.isWithdraw || !getters.taken) return;
      const coinCode = payload.coinCode;
      try {
        const { data, code } = await getUserFirstWithdrawHint({ coinCode });
        if (code === 0) {
          const firstWithdrawHint = data || {};
          if (
            firstWithdrawHint.isWithdraw === "STATUS_BOOL_TRUE" &&
            !getters.user.isWithdraw
          ) {
            commit("wssSetUserInfo", { isWithdraw: true });
          }
          commit("setFirstWithdrawHint", firstWithdrawHint);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getCoinSymbol({ commit, getters }) {
      if (!getters.taken) return;
      const { data, code } = await getWallet();
      if (code === 0) {
        const wallets = data.wallets || [];
        const obj = {};
        wallets.map((v) => {
          obj[v.coinCode] = { ...v };
        });
        commit("setCoinSymbolList", obj);
      }
    },
    async getUserInfo({ commit, dispatch, getters }) {
      try {
        const { data, code, timestamp } = await getUser({});
        if (code === 0) {
          const userInfo = data;
          commit("setUser", userInfo);
          commit("setIsLogin", true);
          dispatch("getUserCoinsAsync");
          localStorage.setItem("defaultCoinCode", userInfo.coinCode);
          // 开启定时器，凌晨上报一次登陆事件
          repairLoginEvent(timestamp);
          // 注册时需要cpf 并且cpf信息为{}
          if (
            userInfo.needBindCpf === "ROW_STATUS_ENABLE" &&
            !userInfo.cpfAccount
          ) {
            commit("setPopBox", {
              show: true,
              views: "cpfInfo",
              data: {
                close: true,
                width: "500px",
              },
            });
          } else {
            commit("setPopBox", {
              show: false,
              views: "cpfInfo",
            });
          }

          // 临时方案  免费金币提现模式下根据用户VIP等级来设置用户选中货币
          const appConfig = getters.getPacketConfig?.appConfig || {};
          const withdrawMode = appConfig.withdrawMode;
          if (withdrawMode === "WITHDRAW_MODE_FREE_GOLD") {
            let selectCoin = "";
            if (userInfo?.level === 0) {
              // vip0 默认选择免费金币
              selectCoin = userInfo?.coinCode + " experience";
            } else {
              // vip1 默认选择真实货币
              selectCoin = userInfo?.coinCode;
            }
            selectWallet({ coinCode: selectCoin }).then(async (res) => {
              commit("setSelectCoin", selectCoin);
            });
          }
          return userInfo;
        }
      } catch (error) {}
    },
    async updateUserInfo({ commit }) {
      const { data, code } = await getUser({});
      if (code === 0) {
        const userInfo = data;
        commit("setUser", userInfo);
        // 注册时需要cpf 并且cpf信息为{}
        if (
          userInfo.needBindCpf === "ROW_STATUS_ENABLE" &&
          !userInfo.cpfAccount
        ) {
          commit("setPopBox", {
            show: true,
            views: "cpfInfo",
            data: {
              close: true,
              width: "500px",
            },
          });
        } else {
          commit("setPopBox", {
            show: false,
            views: "cpfInfo",
          });
        }
      }
    },
    async signOutPs({ commit, state }) {
      removeLocalStorage("evryLoginEvent");
      removeLocalStorage("closeDownloadTime");
      removeLocalStorage("activityfirstWithdrawal");
      // removeLocalStorage("channelId");
      console.log(state.taken, "state.takenstate.taken");
      console.log(state.user, "state.takenstate.user");
      disconnectWallet();
      // if (state.taken) {
      try {
        await loginOut();
      } catch (error) {
        console.log(error);
      }
      // }
      removeToken();
      removeLocalStorage("gameUrl");
      removeLocalStorage("USER_LOGIN_DATA");
      removeLocalStorage("USER_DATA");
      removeLocalStorage("IS_LOGIN");
      commit("setUser", "");
      commit("setTaken", "");
      commit("setIsLogin", false);
      removeLocalStorage("defaultCoinCode");
      removeDataFromIndexDB("userInfo");
      window.location.replace("/home");
      // window.location.reload();
      // console.log("清除信息");
      // Bus.$emit("reload");
    },

    // 获取品牌信息
    async getBrandData({ commit, state }) {
      // const { code, data } = await getBrandInfo();
      // if (code !== 0) return;
      // if (!data) return;
      // commit("setBrandData", data);
    },
    // 注册n
    async registerAction({ commit, dispatch }, payload) {
      commit("setLoginLoading", true);
      try {
        let postData = { ...payload.data };

        eventPost("register");
        postData = {
          ...postData,
          ...getchannel(),
          ...getAdsCode(),
          deviceInfo: { ...getDeviceInfo() },
        };
        const { data, code } = await register(postData);
        if (code === 0) {
          if (data.registerRewardEnable) {
            window.registerRewardEnable = true;
          }
          commit("setTaken", {
            accessToken: data.accessToken,
            refreshToken: data.refreshToken,
          });
          ThirdPartySubmissionStorage(queryToObj(data?.promoteClipboardParams));
          setLocalStorage("USER_LOGIN_DATA", { ...data, sid: data.userSid });

          // 注册送金 手动领取开启
          const registerReward = getLocalStorage('packetDomain');
          if (registerReward && Number(registerReward.activityInfo?.ActivityTypeRegister?.detail?.status) === 1 && Number(registerReward.activityInfo?.ActivityTypeRegister?.detail?.dispatchType) === 2) {
            // 开启注册送金活动
            Bus.$emit("registerRewardShow", {});
          } else {
            const rawardTimer = setTimeout(async () => {
              const rawardRes = await previewActivityReward({
                activityType: "ActivityTypeRegister",
              }); // 注册送金
              const rewardType = rawardRes?.data?.rewardType;
              const isPopup = rawardRes?.data?.isPopup;
              if (
                !rewardType ||
                rewardType === "ACTIVITY_REWARD_TYPE_UNKNOWN" ||
                isPopup === "ROW_STATUS_DISABLE" ||
                isPopup === 2
              ) {
                return false;
              }
              if (rewardType === "ACTIVITY_REWARD_TYPE_MONEY") {
                const amount = rawardRes?.data?.amount
                  ? rawardRes?.data?.amount
                  : 0;
                if (Number(amount) > 0) {
                  Bus.$emit("registerRewardShow", {
                    amount: amount,
                    coinCode: rawardRes?.data?.coinCode,
                    ...rawardRes.data,
                  });
                }
              } else {
                Bus.$emit("registerRewardShow", rawardRes?.data);
              }
              console.log("=======注册奖励弹窗完成======");
              clearTimeout(rawardTimer);
            }, 200);
          }

          // 登陆后的一些操作
          Bus.$emit("loginSuccess", {
            type: "register",
            event: payload.data.type,
            data: {
              ...payload.data,
              ...data,
            },
          });
          // 邀请码
          if (payload.data.inviteCode) {
            setLocalStorage("inviteCode", payload.data.inviteCode || "");
          }

          if (postData.ttclid) {
            removeLocalStorage("ttclid");
          }
          if (postData.fbclid) {
            removeLocalStorage("fbclid");
          }

          setLangFromUser(data);

          const tmer = setTimeout(() => {
            dispatch("getUserInfo");
            commit("setPopBox", { show: false });
            clearTimeout(tmer);
            Bus.$emit("reload");
          }, 300);
        }
        if (code === 1020036 || code === 1020037 || code === 1020067) {
          // 邀請碼非法
          Bus.$emit("showUpdateInviteCode", code, (invite) => {
            dispatch("registerAction", {
              data: { ...payload.data, inviteCode: invite },
            });
            Bus.$emit("showUpdateInviteCode", false);
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        const tmer2 = setTimeout(() => {
          commit("setLoginLoading", false);
          if (window.grecaptcha && window.widgetId !== undefined) {
            window.grecaptcha.reset(window.widgetId);
          }
          clearTimeout(tmer2);
        }, 300);
      }
    },
    // 登陆n
    async loginAction({ commit, dispatch }, payload) {
      commit("setLoginLoading", true);
      try {
        let postData = { ...payload.data };
        console.log(postData);
        eventPost("login_click");
        postData = {
          ...postData,
          ...getchannel(),
          deviceInfo: { ...getDeviceInfo() },
        };
        const { data, code } = await login(postData);
        if (code === 0) {
          commit("setTaken", {
            accessToken: data.accessToken,
            refreshToken: data.refreshToken,
          });
          commit("setIsLogin", true);
          ThirdPartySubmissionStorage(queryToObj(data?.promoteClipboardParams));
          setLocalStorage("USER_LOGIN_DATA", { ...data, sid: data.userSid });
          // 登陆后的一些操作
          Bus.$emit("loginSuccess", {
            type: "login",
            event: payload.data.type,
            data: {
              ...payload.data,
              ...data,
            },
          });

          setLangFromUser(data);

          const tmer = setTimeout(() => {
            dispatch("getUserInfo");
            commit("setPopBox", { show: false });
            clearTimeout(tmer);
            Bus.$emit("reload");
          }, 300);
        }
        if (code === 1020036 || code === 1020037 || code === 1020067) {
          // 邀請碼非法
          Bus.$emit("showUpdateInviteCode", code, (invite) => {
            dispatch("loginAction", {
              data: { ...payload.data, inviteCode: invite },
            });
            Bus.$emit("showUpdateInviteCode", false);
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        const tmer2 = setTimeout(() => {
          commit("setLoginLoading", false);
          if (window.grecaptcha && window.widgetId !== undefined) {
            window.grecaptcha.reset(window.widgetId);
          }
          clearTimeout(tmer2);
        }, 300);
      }
    },
    // 三方登陆注册n
    async thirdLoginAction({ commit, dispatch }, payload) {
      try {
        let postData = { ...payload.data };

        postData = {
          ...postData,
          ...getchannel(),
          ...getAdsCode(),
          deviceInfo: { ...getDeviceInfo() },
        };
        const { data, code } = await thirdLogin(postData);
        if (code === 0) {
          if (data.isRegister && data.registerRewardEnable) {
            window.registerRewardEnable = true;
          }
          commit("setTaken", {
            accessToken: data.accessToken,
            refreshToken: data.refreshToken,
          });
          commit("setIsLogin", true);
          ThirdPartySubmissionStorage(queryToObj(data?.promoteClipboardParams));
          // 登陆后的一些操作
          const typeStr = data.isRegister ? "register" : "login";
          Bus.$emit("loginSuccess", {
            type: typeStr,
            event: payload.data.loginType,
            data: {
              ...payload.data,
              ...data,
            },
          });
          if (data.isRegister) {
            // 调用 预览活动奖励接口
            const registerReward = getLocalStorage('packetDomain');
            if (registerReward && Number(registerReward.activityInfo?.ActivityTypeRegister?.detail?.status) === 1 && Number(registerReward.activityInfo?.ActivityTypeRegister?.detail?.dispatchType) === 2) {
              // 开启注册送金活动
              Bus.$emit("registerRewardShow", {});
            } else {
              const rawardTimer = setTimeout(async () => {
                const rawardRes = await previewActivityReward({
                  activityType: "ActivityTypeRegister",
                }); // 注册送金
                const rewardType = rawardRes?.data?.rewardType;
                const isPopup = rawardRes?.data?.isPopup;
                if (
                  !rewardType ||
                  rewardType === "ACTIVITY_REWARD_TYPE_UNKNOWN" ||
                  isPopup === "ROW_STATUS_DISABLE" ||
                  isPopup === 2
                ) {
                  return false;
                }
                if (rewardType === "ACTIVITY_REWARD_TYPE_MONEY") {
                  const amount = rawardRes?.data?.amount
                    ? rawardRes?.data?.amount
                    : 0;
                  if (Number(amount) > 0) {
                    Bus.$emit("registerRewardShow", {
                      amount: amount,
                      coinCode: rawardRes?.data?.coinCode,
                      ...rawardRes.data,
                    });
                  }
                } else {
                  Bus.$emit("registerRewardShow", rawardRes?.data);
                }
                clearTimeout(rawardTimer);
              }, 200);
            }
            
            // 邀请码
            if (payload.data.inviteCode) {
              setLocalStorage("inviteCode", payload.data.inviteCode || "");
            }
            eventPost("register");
          } else {
            eventPost("login_click");
          }

          if (postData.ttclid) {
            removeLocalStorage("ttclid");
          }
          if (postData.fbclid) {
            removeLocalStorage("fbclid");
          }

          setLangFromUser(data);

          const tmer = setTimeout(() => {
            dispatch("getUserInfo");
            commit("setPopBox", { show: false });
            clearTimeout(tmer);
            Bus.$emit("reload");
          }, 300);
        }
        if (code === 1020036 || code === 1020037 || code === 1020067) {
          Vue.prototype.$nextTick(() => {
            // 邀請碼非法
            Bus.$emit("showUpdateInviteCode", code, (invite) => {
              dispatch("thirdLoginAction", {
                data: { ...payload.data, inviteCode: invite },
              });
              Bus.$emit("showUpdateInviteCode", false);
            });
          });
        }

        return { data, code };
      } catch (error) {
        console.log(error);
      } finally {
        //
        const tmer2 = setTimeout(() => {
          if (window.grecaptcha && window.widgetId !== undefine) {
            window.grecaptcha.reset(window.widgetId);
          }
          clearTimeout(tmer2);
        }, 300);
      }
    },
    // 获取小红点数据
    async getPointApi({ commit, state, dispatch, getters }, payload) {
      if (!getters.taken) return;

      let dataObj = {};
      let redDot = [];
      const arr = [];
      if (payload && payload.data) {
        dataObj = payload.data;
        redDot = payload.data?.redDot || [];
      } else {
        const res = await getRedDot({});
        const { data, code } = res || {};
        if (code === 0) {
          dataObj = data || {};
          redDot = data?.redDot || [];
        }
      }
      // 处理数据
      if (dataObj?.show === "STATUS_BOOL_TRUE" || dataObj?.show === 1) {
        arr.push("JUMP_FUNCTION_TYPE_REWARD"); // 奖金
        arr.push("JUMP_FUNCTION_TYPE_ACTIVITY_CENTER"); // 活动中心
        if (dataObj?.type === 1) {
          if (state.allPoint.includes("JUMP_FUNCTION_TYPE_MAIL")) {
            arr.push("JUMP_FUNCTION_TYPE_MAIL"); // 邮件
            arr.push("JUMP_FUNCTION_TYPE_MESSAGE_CENTER"); // 消息中心
          }
        }
      }
      if (dataObj?.siteEmail === "STATUS_BOOL_TRUE") {
        arr.push("JUMP_FUNCTION_TYPE_MAIL"); // 邮件
        arr.push("JUMP_FUNCTION_TYPE_MESSAGE_CENTER"); // 消息中心
        // 新邮箱
        console.log(dataObj, "新邮箱");
        commit("setNewNotice", true);
        if (dataObj?.type === 2) {
          if (state.allPoint.includes("JUMP_FUNCTION_TYPE_REWARD")) {
            arr.push("JUMP_FUNCTION_TYPE_REWARD"); // 奖金
            arr.push("JUMP_FUNCTION_TYPE_ACTIVITY_CENTER"); // 活动中心
          }
        }
      }
      if (dataObj?.siteEmail === "STATUS_BOOL_FALSE") {
        // 新邮箱
        commit("setNewNotice", false);
      }

      if (dataObj?.hasUnreceivedRewardEmail === "STATUS_BOOL_TRUE") {
        commit("setUnreceivedNotice", { unreceivedNotice: true, amount: dataObj?.waitReceiveAmount });
      }
      if (dataObj?.hasUnreceivedRewardEmail === "STATUS_BOOL_FALSE") {
        // 邮箱
        commit("setUnreceivedNotice", { unreceivedNotice: false, amount: dataObj?.waitReceiveAmount });
      }

      // 初始化数据
      commit("setCurPoint", []);
      commit("setAllPoint", arr);
      commit("setSpecialRedDot", redDot);
    },
    // 刷新接口
    async refreshPageApi({ commit, getters }, payload) {
      if (!getters.taken) return;
      // 默认普通刷新
      const refreshPageType = payload?.type || "RefreshPageType_RefreshPage";
      await refreshPage({ refreshPageType });
    },
    // 获取开启的功能 活动、任务等
    async getEnableFeatureApi({ commit }) {
      const { data, code } = await getEnableFeature();
      if (code === 0) {
        // 初始化数据
        const obj = data || {};
        obj.activityTypes = [];
        if (data.activityInfos && data.activityInfos.length) {
          obj.activityTypes = data.activityInfos.map((v) => {
            return v.activityType;
          });
        }
        commit("setAllEnableFeature", obj);
      }
    },
  },
  getters: {
    getDisplayPromoteUrl(state) {
      return (
        state.displayPromoteUrl ||
        getLocalStorage("displayPromoteUrl") ||
        "ROW_STATUS_DISABLE"
      );
    },
    getDownloadRewardClaimStatus(state) {
      return (
        state.downloadRewardClaimStatus ||
        getLocalStorage("downloadRewardClaimStatus") ||
        false
      );
    },
    getAllPoint(state) {
      return state.allPoint;
    },
    getNewNotice(state) {
      return state.newNotice;
    },
    getUnreceivedNotice(state) {
      return state.unreceivedNoticeObj;
    },
    getCurPoint(state) {
      return state.curPoint;
    },
    getAllEnableFeature(state) {
      return state.enableFeature;
    },
    getFirstWithdrawHint(state) {
      return state.firstWithdrawHint || {};
    },
    taken(state) {
      return state.taken || getToken();
    },
    quickLoginInfo(state) {
      return state.quickLoginInfo;
    },
    user(state) {
      return state.user || getLocalStorage("USER_DATA") || {};
    },
    login(state) {
      return state.isLogin || getLocalStorage("IS_LOGIN") || false;
    },
    loginLoading(state) {
      return state.loginLoading;
    },
    setIpConfig(state) {
      return state.ipConfig || getLocalStorage("IP_CONFIG");
    },
    brandDetail(state) {
      return state.brandData;
    },
  },
};

export default AuthModule;
